import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    backToHomeButton: 'Return home',
    contactUsButton: 'Contact us',
    instantTransferDescription:
      'An error has occurred. Your transfer could not be sent instantly. No money has been debited from your account.',
    regularTransferDescription:
      'An error has occurred. No money has been debited from your account. Please try again, and if the problem persists after 10 minutes, contact us.',
    retryButton: 'Try again',
    retryWithRegularTransferButton: 'Try again with a standard transfer',
    title: 'Your transfer has not been sent',
  },
  fr: {
    backToHomeButton: 'Retour à l’accueil',
    contactUsButton: 'Nous contacter',
    instantTransferDescription:
      'Une erreur s’est produite. Votre virement n’a pas pu être envoyé en instantané. Aucune somme n’a été débitée de votre compte.',
    regularTransferDescription:
      'Une erreur s’est produite. Aucune somme n’a été débitée de votre compte. Veuillez réessayer et si le problème persiste après 10 minutes, contactez-nous.',
    retryButton: 'Réessayer',
    retryWithRegularTransferButton: 'Réessayer en virement standard',
    title: 'Votre virement n’a pas été envoyé',
  },
} as const);

export default locales;
